import React, { useState, useEffect } from 'react';
import { Link as A } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

//style
import './style.scss';

//components
import Filter from './Filter';
import ProjectBox from '../../components/ProjectBox';
import Spinner from '../../components/Spinner';
import ProjectShowcase from '../../components/ProjectShowcase';

export default function Projects() {
  const project = useSelector((state) => state.project);

  const projects = project.projects;

  // Category filter
  const [projectfilter, setProjectfilter] = useState('ALL');
  const [Projects, setProjects] = useState([]);
  const [filterId, setFilterId] = useState('ALL');

  useEffect(() => {
    //limit 6 projects per page
    setProjects(projects);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projects]);

  useEffect(() => {
    if (projects && projectfilter === 'ALL') {
      setProjects(projects);
    }
    // filter projects by role
    const filteredProjects = projects.filter((project) =>
      project.categories.find((item) => item === projectfilter)
    );

    setProjects(filteredProjects);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectfilter]);

  // programming lang filter
  const filters = [
    { filter: 'ALL', id: uuid() },
    { filter: 'Front-End', id: uuid() },
    { filter: 'Back-End', id: uuid() },
    { filter: 'FullStack', id: uuid() },
  ];

  const OnClick = (e) => {
    setProjectfilter(e.target.textContent);

    const filter = filters.find(
      (filter) => filter.filter === e.target.textContent
    );
    setFilterId(filter.filter);
  };

  return (
    <div id="project">
      <div className="overlay"></div>
      <h2 className="project-title">Projects</h2>
      <div className="filters">
        {filters.map((filter) => (
          <Filter
            key={filter.id}
            filterId={filterId}
            filter={filter}
            onClick={OnClick}
          />
        ))}
      </div>
      {project.loading && <Spinner />}
      <ProjectShowcase>
        {Projects &&
          Projects.slice(0, 6).map((project) => (
            <ProjectBox
              key={project._id}
              name={project.name}
              details={project.projectDetails}
              createdWith={project.createdWith}
              projectImage={project.projectImage}
              alt={project.ImageAlt}
              gitlink={project.gitLink}
              live={project.projectLink}
            />
          ))}
      </ProjectShowcase>
      <A className="see-more" to="/projects">
        {projects && projects.length > 6 && <button>See All Projects</button>}
      </A>
    </div>
  );
}
